import React from 'react'
import CalendarView from './view'

class CalendarViewBloc extends CalendarView {

    render() {
        const {key, isWeekend, monthName, dayOfMonth, collection} = this
        return <li className={'calendar-day calendar-bloc' + (isWeekend ? ' calendar-dayWeekend' : '')} key={key}>
            <div className='calendar-day-title'>
                <span>
                    {monthName}
                </span>
                <span>
                    {dayOfMonth}
                </span>
                {collection.map(this.renderDay.bind(this))}
            </div>
        </li>
    }
}
export default CalendarViewBloc
